export default __webpack_public_path__ + "static/media/arrow_search.63cd3819.svg";